module.exports = __webpack_public_path__ + "static/media/warm-up.b2b69fcd.md";